<template>
    <div>
        <div class="pos kzgmain">
            <b> 您的位置：</b>
            <a href="/" title="首页"> 首页 </a><span> &gt; </span>
            <i>
                <router-link :to="{ path: '/HzUs', query: { id: id, name: name } }">{{ name }}
                    <!-- <span> &gt; </span> -->
                </router-link>
            </i>
        </div>
        <div class="aboutbg">
            <div class="about_us kzgmain">
                <div class="wow fadeInLeft2 animate__animated" v-html="profile"></div>
                <div class="about_pic">
                    <img src="../../images/1627013129838689.jpg">
                </div>
            </div>
        </div>
        <div class="honorbg kzgmain">
            <h2 class="honor_title wow fadeInDown2 animate__animated">
                <strong>荣誉资质</strong>
                <img src="../../images/line.png">
            </h2>
            <div class="honor_con">
                <div v-for="(item, index) in honorList" :key="index" :href="item.hiPicture" :title="item.hiTitle">
                    <a :href="item.hiPicture" target="_blank" :title="item.hiTitle">
                        <img :src="item.hiPicture" :alt="item.hiTitle">
                        <h2>{{ item.hiTitle }}</h2>
                    </a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import http from '../../js/axios'
import router from '../../router'

export default {
    name: 'HzUs',
    components: {
        router
    },
    data() {
        return {
            id: this.$route.query.id,
            name: this.$route.query.name,
            image: '',
            briefList: [],
            honorList: [],
            profile: '',
        };
    },
    computed: {},
    watch: {},
    methods: {
        queryAbout() {
            http.get('/hzAboutUsInfo/aboutUs').then(res => {
                this.briefList = res.data.data.result;
                this.briefList.forEach(item => {
                    if (item.uiTypeId === '关于我们') {
                        this.profile = item.uiContent;
                    }
                })
            })
        },
        queryHonor() {
            http.get('/hzHonorInfo/honor').then(res => {
                this.honorList = res.data.data.result;
                this.honorList.forEach(item => {
                    item.hiPicture = this.image + item.hiPicture;
                })
                console.log(this.honorList);
            })
        }
    },
    created() {
        this.image = http.imageURL;
        this.queryAbout();
        this.queryHonor();
    },
    mounted() {

    }
}
</script>

<style>
@import "../../config/Control.css";
@import "../../config/HzUs.css";
</style>


// WEBPACK FOOTER //
// src/views/about/HzUs.vue